import { defineComponent, openBlock, createElementBlock, createElementVNode } from 'vue';
import _export_sfc from './_virtual/plugin-vue_export-helper.mjs';

const _sfc_main = defineComponent({
  name: "Xingxing"
});
const _hoisted_1 = {
  width: "12",
  height: "12",
  viewBox: "0 0 12 12",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2 = /* @__PURE__ */ createElementVNode("path", {
  opacity: "0.35",
  d: "M5.66161 11.2915C5.7975 11.576 6.2025 11.576 6.33839 11.2915L7.82506 8.17862C7.89901 8.02379 8.02379 7.89901 8.17862 7.82506L11.2915 6.33839C11.576 6.2025 11.576 5.7975 11.2915 5.66161L8.17862 4.17494C8.02379 4.10099 7.89901 3.97621 7.82506 3.82138L6.33839 0.70853C6.2025 0.424012 5.7975 0.424012 5.66161 0.70853L4.17494 3.82138C4.10099 3.97621 3.97621 4.10099 3.82138 4.17494L0.70853 5.66161C0.424012 5.7975 0.424012 6.2025 0.70853 6.33839L3.82138 7.82506C3.97621 7.89901 4.10099 8.02379 4.17494 8.17862L5.66161 11.2915Z",
  fill: "url(#paint0_linear_1180_74095)"
}, null, -1);
const _hoisted_3 = /* @__PURE__ */ createElementVNode("defs", null, [
  /* @__PURE__ */ createElementVNode("linearGradient", {
    id: "paint0_linear_1180_74095",
    x1: "12.5511",
    y1: "0.509515",
    x2: "-1.23744",
    y2: "10.7626",
    gradientUnits: "userSpaceOnUse"
  }, [
    /* @__PURE__ */ createElementVNode("stop", { "stop-color": "#3DFFF3" }),
    /* @__PURE__ */ createElementVNode("stop", {
      offset: "1",
      "stop-color": "#2A7BFF"
    })
  ])
], -1);
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _hoisted_4);
}
var xingxing = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render]]);

export { xingxing as default };
